import React, { useEffect, useMemo, useState } from "react";
import FormField from "./FormField";
import { useDispatch, useSelector } from "react-redux";
import { setForm3Options } from "../../../../../services/slices/addformSlice";
import "./stepThree.scss";
import { frequencyOptions, monthOptions, monthWeekOptions, weekOptions } from "../../../../../utils/constants/constants";

const StepThree = ({ setActiveStep, initialData, error, setError }) => {
    const dispatch = useDispatch();
    const [formData, setFormData] = useState(initialData);
    const { timezone: { timeZones }, } = useSelector((state) => state.timezone);
    const { form3Options } = useSelector(state => state?.addShop);
    const { userdetails } = useSelector((state) => state.userDetails);
    const { isVisualize } = userdetails;

    useEffect(() => {
        if (form3Options.charts === "No") {
            setFormData(prev => ({
                ...prev, charts: ""
            }))
            dispatch(setForm3Options({ ...form3Options, charts: [] })); // Dispatch the latest state
        }
        // eslint-disable-next-line
    }, [form3Options.charts])

    const handleChange = (e, fieldName) => {
        const { name, value } = e.target ?? {};
        let newValue = value;

        // Prevent spaces if the field is 'shopname'
        if (name === "shopName") {
            newValue = value.replace(/\s/g, '');
        }
        setFormData(prevData => {
            let updatedData = fieldName === "timeZone" ? { ...prevData, [fieldName]: e.value } : name === "shopName" ? { ...prevData, [name]: newValue } : { ...prevData, [name]: value };
            // Dispatch the updated form data after the change
            dispatch(setForm3Options(updatedData));

            if (name === "frequency") {
                if (value === "daily" || value !== formData?.frequency) {
                    updatedData = { ...updatedData, weekDays: [], monthDays: [], monthDaysAdd: [], customAdd: [] };
                    dispatch(setForm3Options(updatedData));
                }
            }
            if (name === "startDate") {

                updatedData = { ...updatedData }
            }
            return updatedData;
        });
        if (name === "startDate" && form3Options?.needEndDate === "Yes" && form3Options?.endDate < value) {
            setError(prev => ({ ...prev, startDate: "Select Start date lesser than End Date" }))

        }else{

            setError((prev) => ({ ...prev, [name]: "" }));
        }

    };
    const handleClear = () => {
        setFormData(initialData);
    };

    const handleAdd = (e, fieldName) => {
        e.preventDefault()
        if (fieldName === "monthDays" && formData?.frequency === "Monthly") {
            if (formData?.monthDaysAdd?.includes(formData?.monthDays)) {
                console.log("errrrr")
            } else if (fieldName === "monthDays" && formData?.monthDays === null) {
                console.log("nullerr")
            } else {
                setFormData(prevData => {
                    const updatedData = {
                        ...prevData,
                        monthDaysAdd: [
                            ...(Array.isArray(prevData?.monthDaysAdd) ? prevData.monthDaysAdd : []),
                            prevData?.monthDays
                        ],
                        monthDays: null
                    };

                    dispatch(setForm3Options(updatedData)); // Dispatch the latest state

                    return updatedData; // Ensure state is updated correctly
                });
            }

        } else if (fieldName === "monthDays" && formData?.frequency === "Custom") {
            if (!formData?.monthDays) {
                console.log("")
            } else {
                const customData = formData?.weekDays?.length ? `${formData?.weekDays}/${formData.monthDays}` : `${formData.monthDays}`
                const exists = formData?.customAdd?.filter((data) => (data === customData))
                if (exists?.length) {
                    setError((prev) => ({ ...prev, monthDays: "Selected date already added" }))
                } else {
                    setFormData(prevData => {
                        const monthDayStr = String(formData.monthDays);
                        const weekDays = formData?.weekDays || [];
                        let updatedCustomAdd = [...(prevData?.customAdd || [])];

                        const existingIndex = updatedCustomAdd.findIndex(item => item.endsWith(`/${monthDayStr}`));
                        if (existingIndex !== -1 && weekDays.length) {
                            const combinedWeekDays = Array.from(new Set([...weekDays])).sort((a, b) => a - b);
                            updatedCustomAdd[existingIndex] = `${combinedWeekDays.join(',')}/${monthDayStr}`;
                        } else {
                            // Add new entry as usual
                            const newEntry = weekDays.length
                                ? `${weekDays.join(',')}/${monthDayStr}`
                                : monthDayStr;
                            updatedCustomAdd.push(newEntry);
                        }

                        const updatedData = {
                            ...prevData,
                            customAdd: updatedCustomAdd,
                            monthDays: null,
                            weekDays: []
                        };

                        setError((prevData) => ({ ...prevData, monthDays: "" }));
                        dispatch(setForm3Options(updatedData));

                        return updatedData;
                    });

                }
            }

        } else if (fieldName === "time") {
            function convertTo12Hour(time24) {
                const [hourStr, minute] = time24.split(":");
                let hour = parseInt(hourStr, 10);

                hour = hour % 12;
                if (hour === 0) hour = 12; // handle midnight and noon
                const hourFormatted = String(hour).padStart(2, "0");

                return `${hourFormatted}:${minute}`;
            }
            const exists = formData?.deliveryzone?.filter((data) => (data?.startTime === convertTo12Hour(formData?.time) && data?.timeZone === formData?.timeZone))
            if (exists?.length) {
                setError(prev => ({ ...prev, time: "Selected time already added" }))
            } else {
                setFormData(prevData => {
                    const updatedData = {
                        ...prevData,
                        deliveryzone: [...prevData?.deliveryzone, { "startTime": convertTo12Hour(formData?.time), "timeZone": formData?.timeZone }],
                        "time": ""
                    };
                    setError((prevData) => ({ ...prevData, time: "" }))

                    dispatch(setForm3Options(updatedData)); // Dispatch the latest state

                    return updatedData; // Ensure state is updated correctly
                });
            }

        }
    }


    const handleDeleteRefresh = (e, fieldName, value) => {
        e.preventDefault()
        if (fieldName === "monthDays") {
            setFormData(prevData => ({ ...prevData, monthDaysAdd: prevData?.monthDaysAdd.filter(data => data !== value) }));
            setFormData(prevData => {
                const updatedData = {
                    ...prevData,
                    monthDaysAdd: prevData?.monthDaysAdd.filter(data => data !== value)
                };
                dispatch(setForm3Options(updatedData)); // Dispatch the latest state
                return updatedData; // Ensure state is updated correctly

            })
        } else if (fieldName === "custom") {
            setFormData(prevData => {
                const updatedData = {
                    ...prevData,
                    customAdd: prevData?.customAdd.filter(data => data !== value),

                };
                dispatch(setForm3Options(updatedData)); // Dispatch the latest state
                return updatedData; // Ensure state is updated correctly

            })
        } else if (fieldName === "time") {
            setFormData(prevData => {
                const updatedData = {
                    ...prevData,
                    deliveryzone: prevData?.deliveryzone.filter((data) => (data?.startTime !== value?.startTime)),

                };
                dispatch(setForm3Options(updatedData)); // Dispatch the latest state
                return updatedData; // Ensure state is updated correctly

            })
        }
    }

    // Dynamically update fieldsConfig based on selected "route"
    const frequencyConfig = useMemo(() => {
        let config = [
            {
                id: "frequency",
                label: "Set your Flight Shop refresh frequency",
                name: "frequency",
                type: "radio",
                options: frequencyOptions,
                // required: true,
                ClassNames: "flex-radiobox"
            },
            {
                id: "timeZone",
                label: "Deliveries time Zone",
                name: "timeZone",
                type: "searchable-select",
                value: formData?.timeZone,
                options: timeZones?.map(data => ({ label: data?.timezone, value: data?.timezone })),
                ClassNames: "time-selection",
                disabled: formData?.deliveryzone?.length > 0,
            },
            {
                id: "time",
                label: "Select delivery time",
                name: "time",
                type: "time",
                value: formData?.time,
                isButton: true,
                classNames: "timedelivery"
            },
        ];

        if (formData.frequency === "Weekly") { // Show input when "RT" is selected
            config = [
                ...config.slice(0, 1),  // First two elements (route & cabinClass)
                {
                    id: "weekDays",
                    label: "Pick your weeks",
                    name: "weekDays",
                    type: "checkbox",
                    value: formData.weekDays,
                    options: weekOptions,
                    ClassNames: "flex-radiobox flex-checkbox"
                },

                ...config.slice(1) // Remaining elements after the 1st index
            ];
        } else if (formData.frequency === "Monthly") {
            config = [
                ...config.slice(0, 1),  // First two elements (route & cabinClass)
                {
                    id: "monthDays",
                    label: "Pick your days",
                    name: "monthDays",
                    type: "select",
                    value: formData.monthDays,
                    options: monthOptions,
                    isButton: true,
                    addedOption: formData?.monthDaysAdd,
                    ClassNames: "monthly-selection",
                },
                ...config.slice(1) // Remaining elements after the 1st index
            ];
        } else if (formData?.frequency === "Custom") {
            config = [
                ...config.slice(0, 1),  // First two elements (route & cabinClass)
                {
                    id: "weekDays",
                    label: "Pick your weeks",
                    name: "weekDays",
                    type: "checkbox",
                    value: formData.weekDays,
                    options: weekOptions,
                    ClassNames: "flex-radiobox flex-checkbox"
                },
                {
                    id: "monthDays",
                    label: `Pick your ${formData?.weekDays?.length ? "weeks" : "dates"}`,
                    name: "monthDays",
                    type: "select",
                    value: formData.monthDays,
                    options: formData?.weekDays?.length ? monthWeekOptions : monthOptions,
                    isButton: true,
                    addedOption: formData?.customAdd,
                    ClassNames: "monthly-selection"
                },
                ...config.slice(1) // Remaining elements after the 1st index
            ];
        }
        return config;
        // eslint-disable-next-line
    }, [formData?.frequency, formData?.weekDays, formData?.deliveryzone]); // Update when frequency changes

    const fieldsConfig = useMemo(() => {
        let config = [{
            id: "startDate",
            label: "Start date of the Flight Shop",
            name: "startDate",
            minDate: new Date().toISOString().split('T')[0],
            type: "date",
            ClassNames: "date-selection"
        },
        {
            id: "needEndDate",
            label: "Specify end date ?",
            name: "needEndDate",
            type: "radio",
            options: [{ label: "Yes", value: "Yes" }, { label: "No", value: "No" }],
            // required: true,
            ClassNames: "flex-radiobox"
        },
        {
            id: "shopName",
            label: "Name of your Flight Shop",
            name: "shopName",
            type: "text",
            ClassNames: "shopname-selection auto-fill-wd",
            col: 4,
        }
        ]

        if (formData.needEndDate.includes("Yes")) { // Show input when "RT" is selected
            config = [
                ...config.slice(0, 2),  // First two elements (route & cabinClass)
                {
                    id: "endDate",
                    label: "End date of the Flight Shop",
                    name: "endDate",
                    type: "date",
                    minDate: formData?.startDate ? formData?.startDate : new Date().toISOString().split('T')[0],

                    ClassNames: "date-selection"
                },
                ...config.slice(2) // Remaining elements after the 2nd index
            ];
        }
        if (isVisualize) {
            config.push({
                id: "charts",
                label: "",
                name: "charts",
                type: "checkbox",
                options: [{ label: "Enable charts for this shop", value: "Yes" }],
                ClassNames: "checkbox-input rate-parity-label"
            });
        }

        return config;
    }, [formData.needEndDate, formData?.startDate, isVisualize]);

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    return (
        <>
            <form onSubmit={handleSubmit} className="third-stepper">
                <FormField
                    formData={formData}
                    handleChange={handleChange}
                    cancelOnClick={handleClear}
                    setFormData={setFormData}
                    fieldsConfig={frequencyConfig}
                    onClickButton={handleAdd}
                    onDelete={handleDeleteRefresh}
                    labelwid={true}
                    errorMessage={error}

                />
                <FormField
                    formData={formData}
                    handleChange={handleChange}
                    cancelOnClick={handleClear}
                    setFormData={setFormData}
                    fieldsConfig={fieldsConfig}
                    labelwid={true}
                    errorMessage={error}

                />
                <div className="thirdstepper-btns mt-30">
                    <div className="stepper-btn no-translate">
                        <button type="button" className="secondary_button clear-background" onClick={() => setActiveStep(1)}>Previous - Choose Flight Attributes</button><br />
                    </div>
                </div>
            </form>
        </>
    );
};

export default StepThree;


